export default function SpinIcon({ className }: { className?: string }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Spin Icon">
        <path
          id="Spin"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.74302 12.6468V11.4615H3.60742V12.6468C3.60742 15.2678 5.73217 17.3926 8.35318 17.3926H9.54V15.257H8.35318C6.91163 15.257 5.74302 14.0884 5.74302 12.6468ZM8.35318 5.52817H9.54V3.39258H8.35318C5.73217 3.39258 3.60742 5.51733 3.60742 8.13834V9.32594H5.74302V8.13834C5.74302 6.69678 6.91163 5.52817 8.35318 5.52817ZM15.4718 8.13834V9.32594H17.6074V8.13834C17.6074 5.51733 15.4827 3.39258 12.8617 3.39258H11.6756V5.52817H12.8617C14.3032 5.52817 15.4718 6.69678 15.4718 8.13834ZM12.8617 15.257H11.6756V17.3926H12.8617C15.4827 17.3926 17.6074 15.2678 17.6074 12.6468V11.4615H15.4718V12.6468C15.4718 14.0884 14.3032 15.257 12.8617 15.257ZM8.06654 8.99366C8.69705 8.99366 9.20817 8.48254 9.20817 7.85204C9.20817 7.22153 8.69705 6.71041 8.06654 6.71041C7.43604 6.71041 6.92492 7.22153 6.92492 7.85204C6.92492 8.48254 7.43604 8.99366 8.06654 8.99366Z"
        />
      </g>
    </svg>
  );
}
